import React, {Fragment} from 'react';
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

const CommonInput = ({lbl,name,type,place,onChange,value,errors,require,disable}) => {
    return (
        <Fragment>
            <Col lg={12} xl={12}>
                <FormGroup>
                    <Label for={name}>{lbl}{require?<span className="text-danger h6">*</span>:''}</Label>
                    <Input type={type} name={name} id={name} placeholder={place}
                           onChange={onChange} value={value} disabled={disable}/>
                    {errors && <span className='text-danger'>{errors}</span>}
                </FormGroup>
            </Col>
        </Fragment>
    );
};

export default CommonInput;